// src/pages/admin/AdminAnnouncementComposer.jsx
import React, { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabaseClient';
import { toast } from 'react-hot-toast';

const AdminAnnouncementComposer = () => {
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [targetCountry, setTargetCountry] = useState('');
  const [targetCourse, setTargetCourse] = useState('');
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    // Optionally fetch course list from Supabase
    const fetchCourses = async () => {
      const { data, error } = await supabase.from('courses').select('id, title');
      if (!error) setCourses(data);
    };
    fetchCourses();
  }, []);

  const handlePostAnnouncement = async () => {
    if (!title || !message) {
      toast.error('Title and message are required');
      return;
    }

    const audience = {
      ...(targetCountry && { country: targetCountry }),
      ...(targetCourse && { course_id: targetCourse })
    };

    const user = await supabase.auth.getUser();
    const postedBy = user?.data?.user?.id;

    const { error, data } = await supabase.from('announcements').insert({
      title,
      message,
      posted_by: postedBy,
      audience
    }).select().single();

    if (error) {
      toast.error('Failed to post announcement');
      console.error(error);
    } else {
      toast.success('Announcement posted');
      setTitle('');
      setMessage('');
      setTargetCountry('');
      setTargetCourse('');
      generateUserLinks(data.id, audience);
    }
  };

  const generateUserLinks = async (announcementId, audience) => {
    // Fetch users matching filter criteria from registrations
    let query = supabase.from('registrations').select('user_id');

    if (audience.country) query = query.eq('country', audience.country);
    if (audience.course_id) query = query.contains('course_ids', [audience.course_id]);

    const { data, error } = await query;
    if (error) {
      console.error('Failed to fetch users:', error);
      return;
    }

    const inserts = data.map(({ user_id }) => ({
      user_id,
      announcement_id: announcementId,
      is_read: false
    }));

    if (inserts.length) {
      const { error: insertError } = await supabase.from('user_announcements').insert(inserts);
      if (insertError) console.error('Failed to link users to announcement:', insertError);
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">📣 Post Announcement</h2>
      <input
        type="text"
        placeholder="Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        className="w-full p-2 border rounded mb-2"
      />
      <textarea
        placeholder="Message..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        className="w-full p-2 border rounded mb-2"
        rows={5}
      ></textarea>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <input
          type="text"
          placeholder="Target Country (optional)"
          value={targetCountry}
          onChange={(e) => setTargetCountry(e.target.value)}
          className="w-full p-2 border rounded"
        />

        <select
          value={targetCourse}
          onChange={(e) => setTargetCourse(e.target.value)}
          className="w-full p-2 border rounded"
        >
          <option value="">Target Course (optional)</option>
          {courses.map(course => (
            <option key={course.id} value={course.id}>{course.title}</option>
          ))}
        </select>
      </div>

      <button
        onClick={handlePostAnnouncement}
        className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
      >
        Post Announcement
      </button>
    </div>
  );
};

export default AdminAnnouncementComposer;
